<template>
  <el-dialog
    id="editLabel"
    :visible.sync="newVisible"
    :before-close="handleClose"
    title="图片标签管理"
    width="600px">
    <div class="content">
      <FormComp
        v-if="newVisible"
        ref="FileList"
        :form="form"
        class="label-edit" />
      <img
        v-if="!isArray"
        :src="item.url"
        class="img"
        alt="img" >
    </div>
    <AppFormSubmit
      :submitting="loading.submit"
      @submit="submit"
      @cancel="cancel"
    />
  </el-dialog>
</template>

<script>
  import FormComp from '../../../../components/FormComponents/index.vue';
  import * as MaterailServer from '../../../../api/materialManage';

  export default {
    name: "EditLabel",
    components: {
      FormComp,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      item: {
        type: [Object, Array],
      },
      top: [Number, String],
    },
    data() {
      return {
        form: [
          {
            attr: 'tag',
            name: "选择分类",
            value: Array.isArray(this.item) ? [] : this.getInitValue(),
            type: "Cascader",
            props: {
              placeholder: "请选择",
              rules: {
                required: true,
                message: "请选择",
              },
              expandTrigger: 'hover',
              props: { multiple: true },
              dropDownVisible: true,
            },
            options: [],
          },
          {
            attr: 'new_file_name',
            name: '新名称',
            value: Array.isArray(this.item) ? '' : (this.item.new_file_name || this.item.name.slice(this.item.name.indexOf('-') + 1)),
            type: 'Input',
            props: { placeholder: '请输入', rules: { required: false, message: '请输入', target: 'blur' } },
          },
        ],
        newVisible: this.visible,
        loading: {
          submit: false,
        },
        newTop: this.top,
      };
    },
    computed: {
      isArray() {
        return Array.isArray(this.item);
      },
      newValue() {
        const obj = {};
        const data = JSON.parse(JSON.stringify(this.form));
        data.map((v) => {
          if (v.attr === 'tag' && v.value && v.value.length > 0) {
            obj.tag_arr = v.value.map(q => ({
                parent_tag_id: q[0],
                tag_id: q[1],
              }));
          } else {
            obj[v.attr] = v.value;
          }
        });
        return obj;
      },
    },
    watch: {
      top(vl) { this.newTop = vl; },
      newTop(vl) {
        this.$emit('update:top', vl);
        this.calcTop();
      },
      name(vl) {
        this.form[0].value = vl;
      },
      visible: {
        handler(vl) {
          this.newVisible = vl;
          if (vl && !this.isArray) { this.getNewTags(); }
        },
        deep: true,
        immediate: true,
      },
      newVisible(vl) {
        this.$emit('update:visible', vl);
      },
    },
    created() {
      this.init();
    },
    methods: {
      // 获取标签默认值
      async getNewTags() {
        const res = await MaterailServer.getTagsById({ resource_id: this.item.id });
        console.log('res==>', res);
        let arr = [];
        try {
          arr = res.tag_arr.map(v => [v.parent_tag_id, v.tag_id]);
        } catch (e) {
          console.log('err==>', e);
        }
        this.form[0].value = arr;
      },
      // 计算初始化高度
      calcTop() {
        this.$nextTick(() => {
          const div = document.querySelector('#editLabel .el-dialog');
          console.log('div==>', div);
          // div.style.marginTop = `${this.newTop}px`;
        });
      },
      getInitValue() {
        let value = [];
        if (Number.isInteger(this.item.tag_parent_id) && Number.isInteger(this.item.tag_id)) {
          value = [this.item.tag_parent_id, this.item.tag_id];
        }
        return value;
      },
      async init() {
        this.calcTop();
        const res = await MaterailServer.getTags();
        if (res) {
          this.form[0].options = res.map(v => ({
              ...v,
              key: v.id,
              value: v.tag_name,
              children: v.leaf.map(q => ({
                  ...q,
                  key: q.id,
                  value: q.tag_name,
                })),
            }));
        }
      },
      handleClose() {
        this.newVisible = false;
      },
      success() {
        // console.log(url, id, data);
        this.handleClose();
        this.$emit('success', this.newValue);
      },
      submit() {
        if (this.$refs.FileList.validateForm()) {
          // 判断是否多选
          if (this.isArray) {
            this.$emit('success', this.newValue, this.item);
          } else {
            this.$emit('success', this.newValue);
          }
          this.newVisible = false;
          this.clearAll();
        }
      },

      cancel() {
        this.newVisible = false;
        this.$emit("cancel");
        this.clearAll();
      },
      clearAll() {
        this.form[0].value = '';
        this.loading.submit = false;
      },
    },
  };
</script>

<style>
.el-cascader-menu__wrap{
  min-height: 300px;
}
</style>
<style scoped>
  .content{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }
  .content .img{
    width: 80px;
    min-height: 50px;
    object-fit: contain;
    margin-left: 30px;
  }
</style>
